import { ArticleHeading1, ArticleHeading2, LinkButton, UIText3 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import styles from './EtazhiBlackFridayTopBanner.css';
import { getAnimationKeyframes } from './utils';
import { selectEtazhiBlackFridayBannerData } from 'shared/selectors/etazhiBlackFriday';

const animationOptions = {
  duration: 10000,
  iterations: Infinity,
};

export const EtazhiBlackFridayTopBanner: React.FC = () => {
  const bannerData = useSelector(selectEtazhiBlackFridayBannerData);
  const containerRef = React.useRef<HTMLDivElement>(null);
  const textRef = React.useRef<HTMLDivElement>(null);

  React.useLayoutEffect(() => {
    if (containerRef.current && textRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const textWidth = textRef.current.offsetWidth;

      if (textWidth > containerWidth) {
        const offsetWidth = containerWidth - textWidth;
        const keyframes = getAnimationKeyframes(offsetWidth);

        textRef.current.animate(keyframes, animationOptions);
      }
    }
  }, []);

  const handleButtonClick = React.useCallback(() => {
    /**
     * @todo: действие по клику
     */
  }, []);

  if (!bannerData || !bannerData.enabled) {
    return null;
  }

  const { bgImageUrl, logoImageUrl, title, subtitle, footerText, buttonText } = bannerData;

  return (
    <div className={styles['banner']} ref={containerRef} data-testid="etazhi-black-friday-top-banner">
      {bgImageUrl && <div className={styles['bg-image']} style={{ backgroundImage: `url(${bgImageUrl})` }} />}
      <div className={styles['content']}>
        {logoImageUrl && <div className={styles['logo']} style={{ backgroundImage: `url(${logoImageUrl})` }} />}
        <div className={styles['texts']}>
          {title && (
            <div className={styles['title']}>
              <ArticleHeading1 color="text-inverted-default">{title}</ArticleHeading1>
            </div>
          )}
          {subtitle && <ArticleHeading2 color="text-inverted-default">{subtitle}</ArticleHeading2>}
        </div>
        {buttonText && (
          <LinkButton
            href={bannerData.link}
            theme="fill_white_primary"
            onClick={handleButtonClick}
            data-testid="etazhi-black-friday-button"
          >
            {buttonText}
          </LinkButton>
        )}
      </div>
      {footerText && (
        <div className={styles['annotation']}>
          <div className={styles['annotation-text']} ref={textRef}>
            <UIText3 color="text-inverted-default" whiteSpace="nowrap">
              {footerText}
            </UIText3>
          </div>
        </div>
      )}
    </div>
  );
};
